<template>
  <div>
    <div class="top_div">
      <img class="home_banner" src="../../../static/img/餐饮banner.png" />
    </div>
    <div class="top_item_div">
      <div class="top_item">
        <img src="../../../static/img/餐饮icon.png" />
        <p class="title">企事业餐饮运营</p>
      </div>

      <div class="heading_div">
        <p class="heading">一站式膳食餐饮服务</p>
        <p class="heading">解决企业后勤人力问题</p>
        <p class="tv_content">
          宏邦餐饮服务是宁波宏邦保安旗下产业之一，专业为企业、工厂、单位团体提供一站式膳食经营管理餐饮服务。秉承创新美食文化的理念，严格坚守食品健康安全，严苛遵循HACCP管理体系规范操作，为广大企事业单位员工提供丰富健康营养的膳食和细致周到的服务。提高了员工就餐体验，改善员工福利及提高企业员工归属感；同时，简化了企事业单位的工作章程，协助企业控制成本，解决很多企业在后勤瓶颈问题，助力企业更高效的投入到运营管理中去。
        </p>
      </div>
    </div>

    <div class="icon_div">
      <div class="icon_item">
        <img src="../../../static/img/餐饮icon1.png" />
        <p>卫生</p>
      </div>
      <div class="icon_item">
        <img src="../../../static/img/餐饮icon2.png" />
        <p>安全</p>
      </div>
      <div class="icon_item">
        <img src="../../../static/img/餐饮icon3.png" />
        <p>营养</p>
      </div>
      <div class="icon_item">
        <img src="../../../static/img/餐饮icon4.png" />
        <p>健康</p>
      </div>
      <div class="icon_item">
        <img src="../../../static/img/餐饮icon5.png" />
        <p>丰富</p>
      </div>
    </div>

    <div class="honor_div">
      <p>六大管理体系</p>
      <div class="honor_sub">
        <foodView1></foodView1>
      </div>
    </div>
    <div class="honor_div2">
      <p>企事业餐饮运营托管服务</p>
      <div class="honor_sub">
        <foodView2></foodView2>
      </div>
    </div>
    <div class="honor_div3">
      <p>四大资质认证</p>
      <div class="honor_sub">
        <div v-for="(item, index) in BookList1" :key="index">
          <!-- <img class="img1" src="../../../static/img/四大认证.png" /> -->
          <img class="img1" :src="item.img" />
        </div>
      </div>
      <p>多项荣誉认证</p>
      <div class="honor_sub">
        <div v-for="(item, index) in BookList2" :key="index">
          <!-- <img class="img2" src="../../../static/img/荣誉认证.png" /> -->
          <img class="img2" :src="item.img" />
        </div>
      </div>
    </div>
    <!-- <div v-html="Detail.荣誉资质"></div> -->
  </div>
</template>
<script>
import foodView1 from "../view/FoodView1.vue";
import foodView2 from "../view/FoodView2.vue";

export default {
  components: {
    foodView1,
    foodView2,
  },
  data() {
    return {
      Detail: [],
      BookList1: [],
      BookList2: [],
    };
  },
  mounted() {
    this.Init();
  },
  destroyed() {},
  deactivated() {
    this.$destroy();
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      this.Init();
    },
  },
  methods: {
    Init() {
      // this.getDetail();
      this.getBookList1();
      this.getBookList2();
    },
    navto(path) {
      // $(".collapse.in").removeClass("in");
      this.$router.push(path);
    },
    getBookList1() {
      this.$axios.get("api/honorbook/list").then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.BookList1 = response.data.page.list;
          }
        }.bind(this)
      );
    },
    getBookList2() {
      this.$axios.get("api/goodbook/list").then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.BookList2 = response.data.page.list;
          }
        }.bind(this)
      );
    },
    getDetail() {
      this.$axios.get("api/contacts/company").then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.Detail = response.data.data;
          }
        }.bind(this)
      );
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleScroll() {
      $(".num").waypoint(
        () => {
          this.$refs.mynum1.start();
        },
        {
          offset: "80%",
        }
      );
      $(".mynum").waypoint(
        () => {
          this.$refs.mynum.start();
        },
        {
          offset: "80%",
        }
      );
    },
  },
};
</script>
<style lang="stylus" scoped>
.top_div {
  height: 68.5rem;
  width: 100%;
  z-index: -1;
  position: relative;
}

.home_banner {
  width: 100%;
  height: 100%;
  object-fit: cover;
  margin-left: auto;
  margin-right: auto;
  --swiper-pagination-color: var(--textBlue);

  div {
    width: 100%;
    height: 50vw;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.top_item_div {
  width: 100%;
  padding: 0 44rem;
  display: flex;
  justify-content: center;
  margin-top: -10rem;
  z-index: 1;
}

.top_item {
  background: var(--textBlue);
  width: 49rem;
  height: 33rem;
  align-content: center;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.2);
  color: white;

  img {
    margin: 5rem 0;
  }

  .title {
    font-size: 3.5rem;
    font-family: regular;
  }
}

.heading_div {
  margin: 15rem 0 0 10rem;
  width: 63rem;
}

.heading {
  font-size: 3rem;
  color: var(--textBlack);
  text-align: left;
  font-family: regular;
}

.tv_content {
  font-size: 1.8rem;
  color: var(--textBlack);
  text-align: justify;
  font-family: light;
}

.icon_div {
  display: flex;
  color: var(--textGary80);
  font-size: 1.8rem;
  justify-content: space-evenly;
  margin: 8rem 35rem 14rem;

  .icon_item {
    background-image: url('../../../static/img/icon_bg.png');
    width: 18rem;
    height: 18rem;
  }

  img {
    width: 5rem;
    height: 5rem;
    margin: 4rem auto 1rem;
  }
}

.honor_div {
  background: var(--divGaryE250);
  padding: 10rem 40rem;
  color: var(--textBlue);
  font-size: 3.4rem;
  font-family: regular;

  p {
    margin: 0 0 5rem;
  }

  .honor_sub {
    margin:5rem 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .img1 {
    width: 25rem;
    height: 35rem;
    object-fit :contain;
  }

  .img2 {
    width: 30rem;
    height: 25rem;
    object-fit :contain;
  }
}

.honor_div2 {
  background: white;
  padding: 10rem 45rem;
  color: var(--textBlue);
  font-size: 3.4rem;
  font-family: regular;

  p {
    margin: 0 0 5rem;
  }

  .honor_sub {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .img1 {
    width: 29rem;
    height: 40rem;
  }

  .img2 {
    width: 36rem;
    height: 28rem;
  }
}

.honor_div3 {
  background: var(--divGaryE250);
  padding: 10rem 30rem;
  color: var(--textBlue);
  font-size: 3.4rem;
  font-family: regular;

  p {
    margin: 0 0 5rem;
  }

  .honor_sub {
    margin:5rem 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .img1 {
    width: 25rem;
    height: 35rem;
    object-fit :contain;
  }

  .img2 {
    width: 40rem;
    height: auto;
    object-fit :contain;
  }
}

@media screen and (max-width: 800px) {
  .top_item_div {
    padding: 0 1rem;
  }

  .top_item {
    height: 25rem;

    img {
      width: 5rem;
    }
  }

  .heading_div {
    margin-left: 5rem;
  }

  .icon_div {
    margin: 1rem;
  }

  .honor_div {
    padding: 3rem 1rem;
  }
  .honor_div3 {
    padding: 3rem 1rem;
  }

  .honor_div2 {
    padding: 3rem 1rem;
  }
  .honor_div .honor_sub{
    div{
      margin:auto;
    }
  }
  .honor_div3 .honor_sub{
    div{
      margin:auto;
    }
  }
}
</style>